export default function FormField({ label, value, onChange, type = 'text', placeholder, multiline = false, disabled = false }) {
  const baseClasses = "w-full px-3 py-1.5 border-2 border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 rounded-lg shadow-sm text-base text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 placeholder:uppercase placeholder:text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition"

  if (multiline) {
    return (
      <div className="mb-1.5">
        {label && (
          <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
            {label}
          </label>
        )}
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          rows={3}
          className={`${baseClasses} resize-none`}
        />
      </div>
    )
  }

  return (
    <div className="mb-1.5">
      {label && (
        <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
          {label}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={baseClasses}
      />
    </div>
  )
}
